import todosTypes from './todos.types';
import axios from 'axios';
import Socket from 'socket.io-client';
import storage from '../../helpers/storage';

let url;
if (process.env.VUE_APP_NODE_ENV == 'production') {
  url = `https://givemagic-test.herokuapp.com`;
} else {
  url = `https://givemagic-test.herokuapp.com`;
}

const io = Socket(url);

export default {
  fetchTodos({ commit },data) {
    const ls = storage.get('manager');
    commit(todosTypes.FETCH_TODOS_REQUEST);

    const options = {
      url: `${url}/todos/all?resultSize=10&page=${data}`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${ls.token}`
      }
    };
    axios(options)
      .then(res => {
        commit(todosTypes.FETCH_TODOS_SUCCESS, {
          data: { todos: res.data.todos }
        });
      })
      .catch(error => {
        commit(todosTypes.FETCH_TODOS_FAILED, { error });
      });

  },
  editTodo({ commit }, data) {
    const ls = storage.get('manager');
    commit(todosTypes.UPDATE_TODOS_REQUEST);

    const options = {
      url: `${url}/todos/update/${data.id}`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${ls.token}`
      },
      data: {
        cta: data.ctaId,
        status: 'uncompleted',
        assigned_to: data.assigned_to,
        assigned: true,
        supporters: data.supporters
      }
    };
    axios(options)
      .then(res => {
        commit(todosTypes.UPDATE_TODOS_SUCCESS, {
          data: { todos: res.data.todo }
        });
      })
      .catch(error => {
        commit(todosTypes.UPDATE_TODOS_FAILED, { error });
      });

  },
  assignTodo({ commit }, data) {
    const ls = storage.get('manager');
    commit(todosTypes.ADD_TODOS_REQUEST);

    const options = {
      url: `${url}/todos/create`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${ls.token}`
      },
      data: {
        cta: data.cta,
        status: 'uncompleted',
        assigned_to: data.employee,
        assigned: false,
        supporters: data.supporters
      }
    };
    axios(options)
      .then(res => {
        commit(todosTypes.ADD_TODOS_SUCCESS, {
          data: { todos: res.data.todos }
        });
      })
      .catch(error => {
        commit(todosTypes.ADD_TODOS_FAILED, { error });
      });
  },
  deleteTodosRequest({ commit }, data) {
    const ls = storage.get('manager');
    commit(todosTypes.DELETE_TODOS_REQUEST);

    const options = {
      url: `${url}/todos/delete/${data._id}`,
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${ls.token}`
      }
    };
    axios(options)
      .then(res => {
        commit(todosTypes.DELETE_TODOS_SUCCESS, {
          deleted: { todo: res.data.todo }
        });
      })
      .catch(error => {
        commit(todosTypes.DELETE_TODOS_FAILED, { error });
      });
  },
};
